import { render } from "./Endpoints.vue?vue&type=template&id=33987727"
import script from "./Endpoints.vue?vue&type=script&lang=js"
export * from "./Endpoints.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/project/Endpoints.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33987727"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33987727', __exports__)) {
    api.reload('33987727', __exports__)
  }
  
  module.hot.accept("./Endpoints.vue?vue&type=template&id=33987727", () => {
    api.rerender('33987727', render)
  })

}


export default __exports__